// Use environment variables with fallbacks for development
export const apiBaseURL = process.env.REACT_APP_API_URL || "http://localhost:7001";

export const vatRate = parseFloat(process.env.REACT_APP_VAT_RATE) || 1.15;

export const companyNameShort = process.env.REACT_APP_COMPANY_NAME_SHORT || "EcoCape Recycling";
export const companyName = process.env.REACT_APP_COMPANY_NAME || "EcoCape Recycling (Pty) Ltd";